import { MenuItem } from "@app/types";
import { MenuLabel, Role, RoutePath } from "./common.const";
import NotebookIcon from "@app/icons/notebook";
import UserGroupIcon from "@app/icons/user-group";
import CategoryIcon from "@app/icons/category";
import MusicIcon from "@app/icons/music";
import DollarIcon from "@app/icons/dollar";
import CardIcon from "@app/icons/card";
import TagIcon from "@app/icons/tag";
import BannerIcon from "@app/icons/banner";
import AdvertiseIcon from "@app/icons/advertise";
import ContentIcon from "@app/icons/content";
import StatisticsIcon from "@app/icons/statistics";
import SettingIcon from "@app/icons/setting";
import CampaignIcon from "@app/icons/campaign";
import TicketIcon from "@app/icons/ticket";
import MoneySendIcon from "@app/icons/money-send";
import NotificationBingIcon from "@app/icons/notification-bing";
import VideoPlayIcon from "@app/icons/video-play";
import LayerIcon from "@app/icons/layer";
import LogIcon from "@app/icons/log";
import FeedIcon from "@app/icons/feed";
import ClockIcon from "@app/icons/clock";

export const MenuList: readonly MenuItem[] = [
  {
    linkTo: RoutePath.STATISTICS,
    icon: <StatisticsIcon />,
    label: MenuLabel.STATISTICS,
  },
  {
    linkTo: RoutePath.BOOK_MANAGEMENT,
    icon: <NotebookIcon />,
    label: MenuLabel.BOOK_MANAGEMENT,
  },
  {
    linkTo: RoutePath.AUTHOR_BANK,
    icon: <CardIcon />,
    label: MenuLabel.AUTHOR_BANK,
    hasBadge: true,
  },
  {
    linkTo: RoutePath.CATEGORY_MANAGEMENT,
    icon: <CategoryIcon />,
    label: MenuLabel.CATEGORY_MANAGEMENT,
  },
  {
    linkTo: RoutePath.BANNER_MANAGEMENT,
    icon: <BannerIcon />,
    label: MenuLabel.BANNER_MANAGEMENT,
  },
  {
    linkTo: RoutePath.AFFILIATE_CAMPAIGN_MANAGEMENT,
    icon: <BannerIcon />,
    label: MenuLabel.AFFILIATE_CAMPAIGN_MANAGEMENT,
  },
  {
    linkTo: RoutePath.ADVERTISE_MANAGEMENT,
    icon: <AdvertiseIcon />,
    label: MenuLabel.ADVERTISE_MANAGEMENT,
  },
  {
    linkTo: RoutePath.CONTENT_MANAGEMENT,
    icon: <ContentIcon />,
    label: MenuLabel.CONTENT_MANAGEMENT,
  },
  {
    linkTo: RoutePath.USER_MANAGEMENT,
    icon: <UserGroupIcon />,
    label: MenuLabel.USER_MANAGEMENT,
  },
  {
    linkTo: RoutePath.BOOK_TIME_MANAGEMENT,
    icon: <ClockIcon />,
    label: MenuLabel.BOOK_TIME_MANAGEMENT,
  },
  {
    linkTo: RoutePath.LOG_MANAGEMENT,
    icon: <LogIcon />,
    label: MenuLabel.LOG_MANAGEMENT,
  },
  {
    linkTo: RoutePath.FEED_MANAGEMENT,
    icon: <FeedIcon />,
    label: MenuLabel.FEED_MANAGEMENT,
  },
  {
    linkTo: RoutePath.SQL_EDITOR_MANAGEMENT,
    icon: <LogIcon />,
    label: MenuLabel.SQL_EDITOR_MANAGEMENT,
  },
  {
    linkTo: RoutePath.BACKGROUND_MUSIC_MANAGEMENT,
    icon: <MusicIcon />,
    label: MenuLabel.BACKGROUND_MUSIC_MANAGEMENT,
  },
  {
    linkTo: RoutePath.TRANSACTION_MANAGEMENT,
    icon: <DollarIcon />,
    label: MenuLabel.TRANSACTION_MANAGEMENT,
  },
  {
    linkTo: RoutePath.TRANSFER_HISTORY_MANAGEMENT,
    icon: <MoneySendIcon />,
    label: MenuLabel.TRANSFER_HISTORY_MANAGEMENT,
    roles: [Role.ROOT],
  },
  {
    linkTo: RoutePath.BANK_MANAGEMENT,
    icon: <CardIcon />,
    label: MenuLabel.BANK_MANAGEMENT,
  },
  {
    linkTo: RoutePath.VOUCHER_IMPORT,
    icon: <TagIcon />,
    label: MenuLabel.VOUCHER_IMPORT,
    roles: [Role.ROOT],
  },
  // {
  //   linkTo: RoutePath.NOTIFICATION_MANAGEMENT,
  //   icon: <NotificationIcon />,
  //   label: MenuLabel.NOTIFICATION_MANAGEMENT,
  // },
  {
    linkTo: RoutePath.SETTING_MANAGEMENT,
    icon: <SettingIcon />,
    label: MenuLabel.SETTING_MANAGEMENT,
    roles: [Role.ROOT],
  },
  {
    linkTo: RoutePath.CAMPAIGN_MANAGEMENT,
    icon: <CampaignIcon />,
    label: MenuLabel.CAMPAIGN_MANAGEMENT,
  },
  {
    linkTo: RoutePath.VOUCHER_ACTIVE_MANAGEMENT,
    icon: <TicketIcon />,
    label: MenuLabel.VOUCHER_ACTIVE_MANAGEMENT,
  },
  {
    linkTo: RoutePath.ALERT_SYSTEM_MANAGEMENT,
    icon: <NotificationBingIcon />,
    label: MenuLabel.ALERT_SYSTEM_MANAGEMENT,
  },
  {
    linkTo: RoutePath.SETTING_UI_MANAGEMENT,
    icon: <SettingIcon />,
    label: MenuLabel.SETTING_UI_MANAGEMENT,
    roles: [Role.ROOT],
  },
  {
    linkTo: RoutePath.MEDIA_MANAGEMENT,
    icon: <VideoPlayIcon />,
    label: MenuLabel.MEDIA_MANAGEMENT,
  },
  {
    linkTo: RoutePath.BOOK_SEGMENT_MANAGEMENT,
    icon: <LayerIcon />,
    label: MenuLabel.BOOK_SEGMENT_MANAGEMENT,
  },
];
